import React, {useState} from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import "./style.css";

const PasswordInput = ({disableShowPassword = false, disableAutocomplete = false, slotProps, ...props}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <TextField
      {...props}
      type={isVisible ? "text" : "password"}
      autoComplete={disableAutocomplete ? "new-password" : null}
      slotProps={{
        ...slotProps,
        input: {
          endAdornment: !disableShowPassword && (
            <InputAdornment position="end">
              <IconButton onClick={() => setIsVisible(!isVisible)}>
                {isVisible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  );
};

export default PasswordInput;
